import { render, staticRenderFns } from "./addColumn.vue?vue&type=template&id=51b1dd63&scoped=true&"
import script from "./addColumn.vue?vue&type=script&lang=js&"
export * from "./addColumn.vue?vue&type=script&lang=js&"
import style0 from "./addColumn.vue?vue&type=style&index=0&id=51b1dd63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1dd63",
  null
  
)

export default component.exports